import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import ReportIcon from "@mui/icons-material/Report";

function AlertDialog({ open, title, description, onClose, onConfirm, onCancel }) {
  return (
    <Dialog open={open} onClose={onClose}>
      {/* <ReportIcon fontSize="large" /> */}
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="contained">
          취소
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error" autoFocus>
          삭제
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlertDialog;
